module.exports = __webpack_public_path__ + "static/img/btm-LOGO.df55d8f2.png";